import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { VerifyEmailActions } from "./VerifyEmailCard";
import { ShieldAlert, X } from "lucide-react";

/** Listens for 403 email_not_verified responses anywhere in the app and explains what to do. */
export default function VerifyGate() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("fx:email-unverified", handler);
    return () => window.removeEventListener("fx:email-unverified", handler);
  }, []);

  if (!open || !user || user.email_verified) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" data-testid="verify-required-dialog">
      <div className="fx-panel w-full max-w-lg p-7 relative">
        <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-slate-500 hover:text-white" data-testid="verify-required-close"><X size={16} /></button>
        <div className="w-11 h-11 rounded-xl bg-amber-500/10 border border-amber-400/30 flex items-center justify-center">
          <ShieldAlert size={20} className="text-amber-300" />
        </div>
        <h2 className="font-display text-xl font-semibold text-white mt-5">Email verification required</h2>
        <p className="text-sm text-slate-400 mt-2">
          Please verify your email before creating templates or documents. We sent a link to{" "}
          <span className="text-slate-200 mono break-all">{user.email}</span>.
        </p>
        <div className="mt-6"><VerifyEmailActions compact onVerified={() => setOpen(false)} /></div>
      </div>
    </div>
  );
}
